import type { State } from '../index';

export * from './selectors';
export * from './actions';

export const comments: State['comments'] = {};
